import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { IWizItemRenderer, WizBaseCollector, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { FIELD_KIND } from '@wizeoo/akm-compute-lib';

import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'timeline-edit-item-renderer',
  templateUrl: './timeline-edit-item.renderer.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineEditItemRenderer implements IWizItemRenderer<null, PivotField> {
  @HostBinding('style.width') forcedWidth = '100%';
 

  public data: PivotField;

  @Input()
  owner: WizBaseCollector;

  /** affichage de l'icone de conf du champ */
  get showSettings(): boolean {
    if (this.owner.id === 'lstColumn' || this.owner.id === 'lstFilter') {
      return true;
    }
    return false; // la liste de choix contient des pkd, pas des pivotFields
  }

  constructor(public elementRef: ElementRef) {}




  /** l'élément est actuellement est une date */
  public isDate(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id === 'freeList' && this.data.arg.dataType === FIELD_KIND.DATE; // affichage de l'oeil uniquement dans la liste de choix
  }


  /** icone de suppression du champ de la zone de contenu, affichage uniquement dans les zones de drop */
  public isInContentList(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id !== 'freeList';
  }

  /** suppression d'un élément des zones de contenu */
  public doDelete(): void {
    this.owner.wizDataProvider.removeItem(this.data);
    WizEventManager.dispatchEvent(this.owner.elementRef, new WizEvent(WIZ_EVENT_TYPE.DELETE, null, this.data));
  }

  /** ouverture de la sub-pop pour configurer la formule (et à terme, le style) */
  public showConf(): void {
    WizEventManager.dispatchEvent(
      this.owner.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, [this.data, this.owner])
    );
  }


}
